<template>
    <vs-collapse class="v-collapse-custom">
        <vs-collapse-item>
            <div slot="header" class="text-md text-primary flex items-center font-medium v-collapse-custom__header">
                {{ title }}
                <feather-icon class="v-collapse-custom__icon v-collapse-custom__open ml-3" icon="ChevronDownIcon" svgClasses='h-5 w-5' />
                <feather-icon class="v-collapse-custom__icon v-collapse-custom__close ml-3" icon="XIcon" svgClasses='h-5 w-5' />
                <div class="ml-auto flex items-center">
                    <slot name="actions"></slot>
                </div>
            </div>
            <slot></slot>
        </vs-collapse-item>
    </vs-collapse>
</template>

<script>
import FeatherIcon from "../FeatherIcon.vue";
import Button from "../Button/Button.vue";

export default {
    components: {Button, FeatherIcon },
    name: "v-collapse-custom",
    props: {
        title: String,
    },
    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},

    mounted() {
        const openClassName = "open-item";

        this.$el.querySelector(".v-collapse-custom__header").addEventListener("click", () => {
            setTimeout(() => {
                const item = this.$el.querySelector(".vs-collapse-item");
            
                if(item.classList.contains(openClassName)) {
                    this.$emit("toggle", true);
                }
                else {
                    this.$emit("toggle", false);
                }
            }, 0);
        })
    }
};
</script>

<style lang="scss">
.v-collapse-custom {
    padding-left: 0;
    padding-right: 0;
    
    .vs-collapse-item {
        .vs-collapse-item--header {
            padding: 0;

            .vs-collapse-item--icon-header {
                display: none;
            }

            .v-collapse-custom__icon {
                transform: translateY(3px);
            }

            .v-collapse-custom__open {
                display: block;
            }
            .v-collapse-custom__close {
                display: none
            }
        }

        .vs-collapse-item--content {
            .con-content--item {
                padding-left: 0;
                padding-right: 0;
            }
        }

        &.open-item {
             .vs-collapse-item--header {
                .v-collapse-custom__open {
                    display: none;
                }
                .v-collapse-custom__close {
                    display: block;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Collapse/VCollapseCustom.vue